document.addEventListener('DOMContentLoaded', () => {
  const coupon = document.getElementById('coupon-code');
  const toast = document.getElementById('copy-toast');

  if (coupon && toast) {
    coupon.addEventListener('click', () => {
      navigator.clipboard.writeText('SCGWELCOME15OFF');

      toast.style.display = 'block';
      toast.style.opacity = '1';

      setTimeout(() => {
        toast.style.opacity = '0';
      }, 1500);

      setTimeout(() => {
        toast.style.display = 'none';
      }, 1800);
    });
  }
});
